/* eslint-disable import/prefer-default-export */
import type { State } from '../configureStore'
import type { ViewItem } from '../reducers/alerts/filter.alerts.reducer'
import * as FilterActionTypes from '../actionTypes/filter.alerts.action.types'
import * as ReduxHelpers from '@src/utils/reduxHelpers'

// Action Creators
export type ActionTypes = setViewByTimeAction

// Actions
const setViewByTime = (selectedView: ViewItem) =>
  ReduxHelpers.Actions.createPayloadAction(
    FilterActionTypes.CHANGE_VIEW_BY_TIME,
    {
      selectedView
    }
  )
type setViewByTimeAction = ReturnType<typeof setViewByTime>

// Action Creators
export function onChangeViewByTime(selectedView: ViewItem) {
  return (dispatch: any, getState: () => State) => {
    dispatch(setViewByTime(selectedView))
  }
}
